import { persistor, store } from "@/redux/store";
import { logout as logoutAction } from "@/components/login-signup/LoginSignupSlice";
import { clearProfile } from "@/components/profile/profileSlice";

/**
 * Logout function that clears all persisted data and Redux state
 * This should be called when user clicks logout to clear session
 *
 * Usage:
 * import { logout } from "@/utils/logout";
 * await logout();
 * navigate("/login");
 */
export const logout = async () => {
  // Dispatch logout action to clear Redux state
  store.dispatch(logoutAction());

  // Clear profile data
  store.dispatch(clearProfile());

  // Purge all persisted data from redux-persist
  await persistor.purge();

  // Clear localStorage completely (ensures cleanup)
  localStorage.removeItem("persist:root");
};

